import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { setSetting } from "actions";

import { Column } from "components/Layout";
import TabRow from "components/TabSelector/TabRow";

import { ParentSaleTabs } from "constants/sale";
import { Settings } from "constants/settings";

import {
  getBusinessUserSaleLotsRoute,
  getLivestockSaleId,
  getSaleyardName,
} from "lib/navigation";

import {
  getActiveRoleBusinessBoughtSaleLots,
  getActiveRoleBusinessVendorSaleLots,
  getIsBusinessUser,
  getSetting,
} from "selectors";

import { useIsFullScreenWithRouteCheck } from "hooks";

export const BusinessUserTabs = React.memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();

  const isFullScreen = useIsFullScreenWithRouteCheck();

  const isBusinessUser = useSelector(getIsBusinessUser);

  const parentSaleTab = useSelector(getSetting(Settings.parentSaleTab));

  const activeRoleBusinessBoughtSaleLots = useSelector(
    getActiveRoleBusinessBoughtSaleLots,
  );
  const activeRoleBusinessVendorSaleLots = useSelector(
    getActiveRoleBusinessVendorSaleLots,
  );

  const activeRoleBusinessHasTransactedSaleLots =
    activeRoleBusinessBoughtSaleLots.length;

  useEffect(() => {
    // if we have bought tab selected but there are no buyer lots, change to sold
    if (
      parentSaleTab === ParentSaleTabs.BOUGHT &&
      !activeRoleBusinessHasTransactedSaleLots
    ) {
      dispatch(setSetting(Settings.parentSaleTab, ParentSaleTabs.SOLD));
    }
  }, [dispatch, activeRoleBusinessHasTransactedSaleLots, parentSaleTab]);

  if (!isBusinessUser || isFullScreen) {
    return null;
  }

  const setStateSelectedTab = selectedTabId => {
    dispatch(setSetting(Settings.parentSaleTab, selectedTabId));
    history.push(
      getBusinessUserSaleLotsRoute(getSaleyardName(), getLivestockSaleId()),
    );
  };

  const tabs = [
    activeRoleBusinessHasTransactedSaleLots && {
      id: ParentSaleTabs.BOUGHT,
      title: "Bought",
    },
    activeRoleBusinessVendorSaleLots.length && {
      id: ParentSaleTabs.SOLD,
      title: "Sold",
    },
  ].filter(Boolean);

  return (
    <Column printHidden>
      <TabRow
        tabs={tabs}
        selectedTab={parentSaleTab}
        setSelectedTab={setStateSelectedTab}
        backgroundColor="gray95"
      />
    </Column>
  );
});
